import router from './router';
import { useNProgress } from '@/hooks/web/useNProgress';
import { usePermissionStoreWithOut } from '@/store/modules/permission';
import { usePageLoading } from '@/hooks/web/usePageLoading';
import { NO_REDIRECT_WHITE_LIST } from '@/constants';
import { useUserStoreWithOut } from '@/store/modules/user';
import { useStorage } from '@/hooks/web/useStorage';
import { getMenuResource } from '@/api/login/index';
import useSetRoleData from '@/hooks/web/useSetRoleData';

const { start, done } = useNProgress();

const { loadStart, loadDone } = usePageLoading();

const { setStorage } = useStorage('sessionStorage');

router.beforeEach(async (to, from, next) => {
  setStorage('resourceId', to.meta.resourceId);
  start();
  loadStart();

  const permissionStore = usePermissionStoreWithOut();
  const userStore = useUserStoreWithOut();
  const { setRoleData } = useSetRoleData();
  if (userStore.getUserInfo) {
    if (to.path === '/login') {
      next({ path: '/home' });
    } else {
      if (permissionStore.getIsAddRouters) {
        next();
        return;
      }

      // 开发者可根据实际情况进行修改
      const { data } = await getMenuResource();
      await setRoleData(data.employeeAccountCache, data.resList);
      const redirectPath = from.query.redirect || to.path;
      const redirect = decodeURIComponent(redirectPath as string);
      const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect };
      next(nextData);
    }
  } else if (NO_REDIRECT_WHITE_LIST.indexOf(to.path) !== -1) {
    next();
  } else {
    next(`/login?redirect=${to.path}`); // 否则全部重定向到登录页
  }
});

router.afterEach(() => {
  done(); // 结束Progress
  loadDone();
});
